import { useMemo } from 'react';
import { useEmployeeManager, useEmployees } from '@/shared/hooks/useEmployees';
import {
  useManagerDirectEmployeesWithMeetings,
  useGetProfessionalMeetingsAsManager,
} from '@/shared/hooks/useOneOnOne';
import { useEmployeeContext } from '@/shared/contexts/EmployeeContext';
import {
  groupProfessionalMeetings,
  type GroupedProfessionalMeeting,
} from '../utils/group-professional-meetings';

export type { GroupedProfessionalMeeting };

export const useOneOnOneMeetings = () => {
  const currentEmployee = useEmployeeContext();
  const { data: manager, isLoading: isLoadingManager } = useEmployeeManager(
    currentEmployee._id,
    currentEmployee.companyId
  );

  const { data: managedEmployees, isLoading: isLoadingEmployees } =
    useManagerDirectEmployeesWithMeetings(currentEmployee._id);

  // Fetch all employees for enriching professional meetings
  const { data: allEmployees = [] } = useEmployees({
    isActive: true,
  });

  const { data: professionalMeetingsAsManagerData = [] } =
    useGetProfessionalMeetingsAsManager({
      employeeId: currentEmployee._id,
    });

  const professionalMeetingsAsManager = useMemo(
    () =>
      groupProfessionalMeetings(
        professionalMeetingsAsManagerData,
        allEmployees,
        'employeeId'
      ),
    [professionalMeetingsAsManagerData, allEmployees]
  );

  return {
    manager,
    managedEmployees,
    isLoadingManager,
    isLoadingEmployees,
    allEmployees,
    professionalMeetingsAsManager,
  };
};
